import styled from "styled-components";
import {
  greyDark,
  primary,
  grey,
  accentLight,
  lightInactive,
  primayColor,
  secondaryColor,
  white,
  advancedPanelSliderWidth,
  sidebarItemDetailSliderWidth,
  studioFooterColor,
  accent,
  blackAlpha008,
  onHoverDropShadow,
} from "../variable";
import { TO_OPEN_SLIDER } from "../../../_reducers/sidebarSliderReducer";
import { DASHBOARD_BANNER } from "../../../_utils/constants";
import { AI_PANEL } from "../../details/constants";

export const StyledTemplatesContainer = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;

    .infinite-scroller-container {
      @media (max-width: 768px) {
        overflow-y: auto;
        padding: 0 1rem 1rem 1rem;
      }
    }
  }
`;

export const StyledMarketplaceContent = styled.div`
  color: ${lightInactive};
  padding: unset;
  height: auto;
  height: 100%;

  .search-bar-row {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 1rem;
  }

  .start-from-scratch-hero-container {
    width: 96%;
    margin: 0rem auto;
  }

  .dashboard-my-assets-dropzone {
    margin: 1.5rem auto 0rem auto;
    width: 95%;
  }

  &.scratch {
    @media (max-width: 768px) {
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }
`;

export const StyledMarketplaceFooter = styled.div`
  background-color: #323232;
  border-radius: 0 0 4px 4px;
  width: 100%;
  height: 63px;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  justify-content: center;
`;

export const StyledMarketplaceFrameTitle = styled.div`
  font-size: 14px;
  letter-spacing: 0;
  line-height: 19px;
  text-align: left;
`;

export const StyledMarketplaceProjectFormatTitle = styled(
  StyledMarketplaceFrameTitle
)`
  color: #bfbfbf;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &.marketplace-template-formats-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const StyledMarketplaceFrameSubtitle = styled.div`
  font-size: 12px;
  letter-spacing: 0;
  margin: 0;
  color: ${grey};
`;

export const StyledMarketplaceFrameDescription = styled.div`
  color: #bfbfbf;
  font-size: 12px;
  text-align: left;
  line-height: 14px;

  &.marketplace-template-formats-description {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const StyledMarketplaceSearchContentContainer = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

export const StyledMarketPlaceGallery = styled.div`
  margin: ${(props) =>
    props.renderlocation === AI_PANEL
      ? "0.25rem -0.15rem"
    : props.renderlocation === "calendar" ||
      props.renderlocation === "editor" ||
      props.renderlocation === "projects"
      ? "0"
      : null};
  padding: ${(props) =>
    props.renderlocation === AI_PANEL
      ? "0"
    : props.renderlocation === "calendar" ||
      props.renderlocation === "editor"
      ? "0"
      : "2.5rem"};
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 357px);
  position: relative;
  flex-wrap: nowrap;

  @media (max-width: 768px) {
    padding: ${(props) => props.renderlocation === "view-all-format-templates"
    ? "0"
    : "1rem"
  };
    overflow: auto;
    min-height: calc(100vh - 127px);
  }

  .view-all-header {
    text-align: center;
    font-size: 36px;
    font-weight: 600;
    text-transform: capitalize;
  }

  .marketplace-templates-no-content-container {
    height: 20%;
    width: 100%;
    position: absolute;
    top: 115%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const StyledMarketplaceHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 12px 0px;

  .header {
    color: ${lightInactive};
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0;
    text-transform: capitalize;
  }

  .view-all {
    cursor: pointer;
    font-size: 14px;
    color: ${lightInactive};
  }
`;

export const StyledMarkerplaceCollection = styled.div`
  display: flex;
  max-width: 100%;
`;

export const StyledMarkerplaceCard = styled.div`
  display: flex;
  ${"" /* height: auto;
  this is causing templates to appear huge in safari.
  if chrome/firefox is affecting because of removing this then find a workaround for safari */
  }
  aspect-ratio: ${(props) => props.width / props.height};
  overflow: hidden;
  border-radius: 8px;

  .template-marketplace-empty-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #232323;
    border-radius: 8px;
    color: ${lightInactive};
    border: 3px solid transparent;
    transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
      0.3s box-shadow,
      0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);

    .icon-container {
      width: 40px;
      height: 40px;
      background-color: rgba(255, 255, 255, 0.08);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    span {
      text-align: center;
      font-size: 16px;
      margin-top: 0.5rem;
    }

    svg {
      font-size: 18px;
    }

    :hover {
      cursor: pointer;
      box-shadow: 0px 0px 40px ${onHoverDropShadow};
      -webkit-box-shadow: 0px 0px 40px ${onHoverDropShadow};
      -moz-box-shadow: 0px 0px 40px ${onHoverDropShadow};
    }
  }
`;

export const StyledAssetsCard = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: #232323;
  position: relative;
  cursor: ${(props) => props?.cursor ?? "pointer"};

  &:hover {
    box-shadow: 0px 0px 40px ${onHoverDropShadow};
    -webkit-box-shadow: 0px 0px 40px ${onHoverDropShadow};
    -moz-box-shadow: 0px 0px 40px ${onHoverDropShadow};
  }

  .holder {
    height: ${(props) => (props.autoHeight ? "auto" : "194px")};
    ${({ autoHeight }) => autoHeight && `min-height: 194px;`}
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 8px 8px 0 0;

    .thumbnail {
      height: 100%;
      width: inherit;

      img {
        opacity: 1;
        width: 100%;
        height: 100%;
        border-radius: 8px;
        object-fit: contain;
      }
    }
  }

  .footer {
    background-color: ${greyDark};
    padding: 8px 12px;
    border-radius: 0 0 8px 8px;
  }

  .title-content {
    z-index: 1;

    .edit-icon {
      margin-left: 6px;
      cursor: pointer;
    }

    input {
      background-color: #232323;
      outline: none;
      border: 0;
      border-bottom: 2px solid #323232;
    }

    .title {
      color: ${lightInactive};
      font-size: 14px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  .date {
    color: #888888;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;

export const HomeTitleRow = styled.div`
  @media (max-width: 768px) {
    padding: 0 1rem;
    gap: 1.5rem;
  }

  .search-icon {
    cursor: pointer;
    margin-left: 12px;
  }

  .create-folder-icon {
    margin-left: 1.25rem;
    cursor: pointer;
  }

  h4 {
    color: ${lightInactive};
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    font-weight: 500;
    margin-bottom: 0px;
  }

  .title {
    font-size: 20px;
    font-weight: bold;
    -webkit-letter-spacing: 0;
    -moz-letter-spacing: 0;
    -ms-letter-spacing: 0;
    letter-spacing: 0;
    line-height: 24px;
  }
`;

export const HomeSelectionRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: ${(props) =>
    props.marginBottom ? props.marginBottom : "0rem"};
  min-height: 62px;
  background-color: #323232;
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "-1.5rem")};
  padding: 0 3.5rem;
  position: sticky;
  top: 55px;
  z-index: 100;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.5);

  .count {
    margin-right: 14px;
    color: ${lightInactive};
  }

  .action-items {
    display: flex;
    align-items: center;

    & > div,
    & > svg {
      cursor: pointer;
      margin-right: 20px;
      margin-left: 20px;
    }

    svg {
      font-size: 18px;
    }
  }
`;

export const QuickStartComponent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2.5rem;
  padding-top: 0.5rem;

  @media (max-width: 768px) {
    padding: 1rem;
    margin-top: unset;
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
    background-color: #1e1e1e;
    margin-top: -1.5rem !important;
  }

  .section {
    width: 100%;
    display: flex;
    flex-direction: column;

    h3 {
      color: ${lightInactive};
      font-family: Rubik;
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
      margin-bottom: 16px;
    }

    .view-all {
      text-decoration: underline;
      margin-right: 8px;
      cursor: pointer;
    }

    .view-all-icon {
      cursor: pointer;
    }

    .recent-items {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(296px, 1fr));
      grid-gap: 40px 10px;
      grid-auto-rows: minmax(280px, 280px);
    }

    .row {
      margin: 0px;

      .card {
        color: ${lightInactive};
        border: 3px solid #323232;
        border-radius: 8px;
        background-color: transparent;
        margin-right: 8px;
        margin-left: 8px;
        padding: 20px;
        align-items: center;

        &:first-child {
          margin-left: 0px;
        }

        .action-button-holder {
          display: flex;
          width: 100%;
          justify-content: space-around;
          align-items: center;
          margin-bottom: 28px;
          flex-wrap: wrap;

          .action-button {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .icon-holder {
              height: 80px;
              width: 80px;
              border-radius: 40px;
              background-color: rgba(255, 255, 255, 0.12);
              display: flex;
              justify-content: center;
              align-items: center;
              margin-bottom: 16px;
              cursor: pointer;
            }

            .title {
              color: #ffac41;
              font-size: 20px;
              letter-spacing: 0;
              line-height: 24px;
              text-align: center;
              cursor: pointer;
            }
          }
        }

        .title {
          font-weight: bold;
          font-size: 20px;
          text-align: center;
        }

        .description {
          font-size: 14px;
          letter-spacing: 0;
          line-height: 17px;
          text-align: center;
        }

        button {
          color: ${lightInactive};

          svg {
            margin-right: 8px;
          }
        }
      }
    }
  }
`;

export const CheckboxComponent = styled.div`
  ${(props) =>
    props.hasAbsolutePosition
      ? `
  position: absolute;
  background-color: #232323;
  `
      : ""};
  cursor: pointer;
  top: -9px;
  left: -6px;
  z-index: 99;
  border-radius: 50%;
`;

export const MoveFolderSlide = styled.div`
  display: flex;
  flex-direction: column;
  height: 250px;
  overflow: auto;

  .move-folder-item {
    cursor: pointer;
    padding: 6px 6px;
    border-radius: 4px;
    margin: 2px 0px;
    display: flex;
    align-items: center;

    .arrow {
      margin-right: 12px;
    }

    &.selected {
      background: ${accentLight};
      color: black;
    }

    .name {
      font-size: 16px;
      letter-spacing: 0.08px;
      flex-grow: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .no-folders-content {
    width: fit-content;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
`;

export const EmptyScreenComponent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 75vh;
  margin-top: -1.5rem;

  &.planner-empty-screen {
    height: unset !important;
    margin-top: unset !important;
    margin-bottom: 1rem;
  }

  h1 {
    color: ${grey};
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 28px;
    margin-bottom: 0px;

    @media (max-width: 768px) {
      margin-left: 16px;
      margin-right: 16px;
    }
  }

  img {
    margin-top: 30px;
    margin-bottom: 20px;
  }

  p {
    color: ${grey};
    font-size: 16px;
    letter-spacing: 0;
    line-height: 30px;
    text-align: center;
    margin-bottom: 4px;
  }

  a {
    text-decoration: none;
    color: ${accentLight};
  }
`;

export const HomeComponent = styled.div`
  height: 100%;
  margin-top: ${(props) => props.isMobileView ? "0" : "1rem"};

  .view-all-template-infinite-scroll {
    grid-template-columns: repeat(auto-fill, minmax(296px, 1fr));
    grid-auto-rows: minmax(280px, 280px);
    grid-gap: 40px 10px;
    padding-top: 3px;
    overflow: unset !important;
  }

  .swiper-story-card {
    z-index: 1;

    :hover {
      z-index: 999;
    }
  }
`;

export const StyledMarkerplaceHelpText = styled(StyledMarketplaceFrameTitle)`
  margin-top: 0px;
  color: ${grey};
  text-align: center;

  &.marketplace-template-subheader,
  &.marketplace-view-all-template-subheader {
    text-align: start;
  }
`;

export const StyledSearchSuggestionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;

  .suggestion-box {
    max-height: 350px;
    height: auto;
    ${(props) => `width: ${props.width}`};
    display: flex;
    flex-direction: column;
    background-color: ${(props) =>
  props.location === "dashboard"
    ? `${secondaryColor}`
    : props.location === "studio"
        ? `${primayColor}`
        : "none"};
    margin: auto;
    border-radius: 8px;
    position: absolute;
    z-index: 20;
    margin-top: 0.75rem;
    overflow-y: auto;
    -webkit-box-shadow: 0 8px 40px 0 rgba(0, 0, 0, 0.5);
    -moz-box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.5);
    box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.5);

    .show-all-item {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin: 0.5rem 0rem;
      padding: 0rem 1rem;

      svg {
        path {
          fill: ${lightInactive};
        }
      }

      .searched-keyword {
        margin-bottom: 0.25rem !important;
        padding: 0rem 1rem;
      }

      :hover {
        background-color: ${studioFooterColor};
        cursor: pointer;
      }
    }

    .title {
      font-size: 16px;
      font-weight: 500;
      padding: 0rem 1rem;
      margin: 0.5rem 0rem 0rem 0rem !important;
      color: ${grey};
    }
  }
`;

export const StyledMobileSearchSuggestionContainer = styled(
  StyledSearchSuggestionContainer
)`
  .suggestion-box {
    background-color: ${primayColor};
    width: 98%;
    margin-top: 0px;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    top: ${(props) => (props.top ? `${props.top}` : "70px")};
    left: 0;
    border-radius: 0px;
    max-height: 100%;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const StyledTemplateViewAllSwiperButton = styled.div`
  /* Extra small devices (phones, 600px and below) */
  @media (max-width: 600px) {
    display: none;
  }

  color: ${white};
  position: absolute;
  top: 0px !important;
  z-index: 2;
  height: 100%;
  width: 96px;
  font-size: 28px;
  background: ${(props) =>
    props.variance === "right"
      ? `linear-gradient(90deg, rgba(30,30,30,0) 0%, ${primayColor} 100%)`
      : props.variance === "left"
      ? `linear-gradient(270deg, rgba(30,30,30,0) 0%, ${primayColor} 100%)`
      : ""};

  .swiper-button-inner-div {
    opacity: ${(props) =>
  props.variance === "right" && props.disabled
    ? 0
    : props.variance === "left" && props.disabled
        ? 0
        : 0.6};
    background-color: ${primayColor};
    border-radius: 50%;
    height: 55px;
    width: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    ${(props) =>
  props.variance === "right" &&
    `
      right: 0;
    `};
    ${(props) =>
  props.variance === "left" &&
    `
      left: 0;
    `};

    ${(props) =>
  !props.disabled
    ? `
      :hover {
        opacity: 1;
      }
    `
    : ""};
  }

  ${(props) =>
    props.variance === "right" &&
    `
    right: 0;
  `};

  ${(props) =>
    props.variance === "right" &&
    props.isactionpanelopen === "true" &&
    `
    right: ${advancedPanelSliderWidth};
  `};

  ${(props) =>
    props.variance === "left" &&
    `
    left: 0;
  `};

  ${(props) =>
    props.variance === "left" &&
    props.slideropen === TO_OPEN_SLIDER &&
    `
    left: ${sidebarItemDetailSliderWidth};
  `};
  mix-blend-mode: difference;
  cursor: ${(props) =>
    props.variance === "right" && props.disabled
      ? "default"
      : props.variance === "left" && props.disabled
      ? "default"
      : "pointer"};
`;

export const StyledVideoResponsive = styled.div`
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;

  iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
  }
`;

export const StyledTemplateFormatsSwiperContainer = styled.div`
  margin: 1.25rem 0rem 0rem 0rem;
  transition: all 0.3s ease;

  &.visible {
    visibility: visible;
    opacity: 1;
    max-height: fit-content;
  }

  &.hidden {
    visibility: hidden;
    opacity: 0;
    max-height: 0;
    margin: 0rem !important;
  }
`;

export const StyledSectionTitleRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 36px;

  .view-all {
    text-decoration: none !important;
    margin-right: 8px;
    cursor: pointer;
    font-size: 14px;
    color: ${lightInactive};
    display: flex;
    align-items: center;
  }
`;

export const StyledSectionTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  -webkit-letter-spacing: 0;
  -moz-letter-spacing: 0;-
  -ms-letter-spacing: 0;
  letter-spacing: 0;
  line-height: 24px;
  color: ${lightInactive};
  @media (max-width: 768px) {
    font-size: 1rem !important;
  }
`;

export const StyledViewAllTemplatesInfiniteScrollGrid = styled.div`
  display: grid;
  grid-gap: 20px;
  ${(props) => `grid-template-columns: repeat(${props.templatesPerRow}, 1fr)`};

  /* Extra small devices (phones, 600px and below) */
  @media (max-width: 600px) {
    ${(props) =>
  props.templatesPerRow <= 4
    ? `grid-template-columns: repeat(1, 1fr)`
    : `grid-template-columns: repeat(2, 1fr)`};
  }
`;

export const StyledPaymentStatusModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .icon {
    font-size: 88px;
    display: flex;
    align-items: center;
    margin-bottom: 1rem !important;
    color: ${(props) =>
  props.status === "success"
    ? "#85DE55"
    : props.status === "error"
        ? "#c84b4b"
        : `${accent}`};
  }

  .title {
    font-size: 18px;
    font-weight: 500;
    color: ${(props) =>
  props.status === "success"
    ? "#85DE55"
    : props.status === "error"
        ? "#c84b4b"
        : `${accent}`};
  }

  .body-text {
    margin-bottom: unset !important;
  }
`;

export const StyledDashboardBannerRow = styled.div`
  min-height: 344px;
  width: 100%;
  border-radius: 8px;
  background: url(${DASHBOARD_BANNER}) rgba(0, 0, 0, 0.8);
  background-repeat: no-repeat;
  background-origin: content-box;
  background-size: cover;
  background-position: center;
  background-blend-mode: multiply;
  align-items: center;
  justify-content: center;
  gap: 20px;

  &.search-template-size {
    width: unset;
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  @media (max-width: 768px) {
    min-height: 200px;
  }
`;

export const StyledDashboardGetStartedBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  // width: 80%;
  justify-content: center;
  padding-left: 1rem;
  padding-right: 1rem;
`;

export const StyledDashboardGetStartedBox = styled.div`
  background-color: ${studioFooterColor};
  min-height: 166px;
  max-width:250px;
  border-radius: 8px;
  position: relative;
  padding: 0.5rem;
  :hover {
    box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.5);
    cursor: pointer;

    .view-all {
      color: ${accent};
    }
    .action {
      visibility: visible !important;
    }
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  transition: transform 0.5s;
`;

export const StyledSimplifiedSpan = styled.span`
  color: ${primary};
`;

export const StyledGetStartedDetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledMarketplaceMasonryView = styled.div`
  height: 0;

  .item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    white-space: nowrap;
    overflow: hidden;
    position: relative;
    ${"" /* width: ${props => props.isSidebarOpen ? "215px" : "200px"}; */}
    width: 10%;

    @media (max-width: 600px) {
      width: 45%;
    }
    @media (min-width: 600px) {
      width: 45%;
    }
    @media (min-width: 768px) {
      width: 30.35%;
    }
    @media (min-width: 992px) {
      width: 31%;
    }
    @media (min-width: 1200px) {
      width: 15.3%;
    }

    :hover {
      box-shadow: 0px 0px 40px #000000;
      -webkit-box-shadow: 0px 0px 40px #000000;
      -moz-box-shadow: 0px 0px 40px #000000;
      border: none;

      .overlay-info-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    }

    .label-container {
      background-color: #1e1e1e;
      color: #939393;
      display: flex;
      position: absolute;
      right: 0;
      top: 0;
      margin: 8px;
      padding: 8px;
      border-radius: 50%;
      z-index: 2;
      font-size: 14px;
    }

    .thumbnail {
      min-width: -webkit-fill-available;
      max-height: inherit;
      overflow: hidden;
      border-radius: 8px;
      position: relative;

      img {
        object-fit: cover;
        width: 100%;
      }
    }

    .overlay-info-container {
      height: 100%;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.6);
      position: absolute;
      display: none;
    }
  }
`;

export const StyledTitleRowWrapper = styled.div`
  .d-sm-search-container {
  }
`;

export const StyledFormatCard = styled(StyledMarkerplaceCard)`
  flex-direction: column;
`;

export const StyledPlannerContainer = styled.div`
  min-height: calc(100vh - 70px);
  display: flex;
  flex-direction: column;

  ${(props) =>
    props.fullScreenEnabled && {
      background: primayColor,
      position: "fixed",
      inset: 0,
      overflow: "auto",
      zIndex: "1005",
    }}

  .tldr-calendar-box {
    margin-left: var(--chakra-space-4);
    margin-right: var(--chakra-space-4);

    @media (max-width: 768px) {
      margin-left: 0;
      margin-right: 0;
    }

    ${(props) =>
  props.isChannelsSidebarOpen
    ? `
    transition: margin-left 0.5s;
    margin-left: 297px;
  `
    : props.isDraftPostsSidebarOpen
        ? `
    transition: margin-right 0.5s;
    margin-right: 360px;
  `
        : ""};
  }
`;

export const StyledPlannerNavbar = styled.div`
  max-width: 100%;
  position: sticky;
  top: ${(props) => (props.fullScreenEnabled ? "0" : "50px")};
  z-index: 4;
  color: #fff;

  ${(props) =>
    props.isChannelsSidebarOpen
      ? `
    transition: margin-left 0.5s;
    margin-left: 281px;
  `
      : props.isDraftPostsSidebarOpen
      ? `
    transition: margin-right 0.5s;
    margin-right: 360px;
  `
      : ""};

  @media (max-width: 768px) {
    top: 0;
  }

  .heading {
    font-weight: 500;
    font-size: 1.1rem;
    margin-right: 1rem;
  }

  .sub-heading {
    font-weight: normal;
    font-size: 14px;
  }

  .sidebar-toggle-btn {
    margin: 0 1rem 0 0.25rem;
    font-size: 22px;

    &.active {
      color: ${accent};
    }

    :hover {
      color: ${accent};
      cursor: pointer;
    }
  }

  .planner-actions {
    display: flex;
    align-items: center;
    flex-direction: row;
  }
`;

export const StyledChannelsSidebar = styled.div`
  height: ${(props) =>
    props.fullScreenEnabled ? "100vh" : "calc(100vh - 50px)"};
  width: 281px;
  position: fixed;
  display: flex;
  flex-direction: column;
  z-index: 100;
  top: ${(props) => (props.fullScreenEnabled ? "0" : "50px")};
  background-color: ${primayColor};
  overflow-x: hidden;
  transition: 0.5s;
  padding: 16px 0 0 0;
  border-right: 1px solid ${blackAlpha008};
  box-shadow: 0 8px 16px 0 rgb(0 0 0 / 50%);

  @media (max-width: 768px) {
    width: 100%;
    left: 0;
  }

  .channels-wrapper {
    flex: 1;
    overflow: auto;
  }

  .accordion-card {
    border-radius: 0px;
    background-color: ${blackAlpha008};

    &.inactive {
      background-color: rgba(0, 0, 0, 0.08);
    }

    .action-btn {
      background-color: transparent;
      border: none;
    }

    .accordion-card-header {
      padding: 6px 14px 6px 12px;
      color: ${white};
      cursor: pointer;

      .accordion-card-body,
      .collapsible-title-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }
`;

export const StyledDraftListSidebar = styled(StyledChannelsSidebar)`
  width: 360px;
  left: unset;
  border: 0;
  box-shadow: 0 8px 16px 0 ${onHoverDropShadow};
  -webkit-box-shadow: 0 8px 16px 0 ${onHoverDropShadow};
  -moz-box-shadow: 0 8px 16px 0 ${onHoverDropShadow};
  background-color: #323232;
`;
